export const FlowModalEvent = {
  ADD_ANOTHER: 'FlowModalEvent:add-another',
  CLOSE: 'FlowModalEvent:CLOSE'
};
